import { render } from "./TCamionesIndex.vue?vue&type=template&id=2510517c"
import script from "./TCamionesIndex.vue?vue&type=script&lang=js"
export * from "./TCamionesIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/cruds/TCamionesIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2510517c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2510517c', __exports__)) {
    api.reload('2510517c', __exports__)
  }
  
  module.hot.accept("./TCamionesIndex.vue?vue&type=template&id=2510517c", () => {
    api.rerender('2510517c', render)
  })

}


export default __exports__